export default "__VITE_ASSET__DIuGKa5d__"